/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


const advantagesLegalbirdAttorneySectionStyle = {
  container: {
    textAlign: "center",
  },
  title: {
    color: "primary.main",
    textAlign: "center",
  },
  advantageTitle: {
    color: "primary.main",
    fontWeight: 500,
    fontSize: "1.25rem",
    textAlign: "center",
  },
  description: {
    maxWidth: "250px",
    margin: "0 auto",
    padding: 0,
    listStyleType: "none",
    "& > li": {
      paddingBottom: "10px",
    },
  },
  imageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "132px",
    padding: "20px",
  },
  iconImage: {
    height: "100%",
    width: "100%",
  },
  gridItem: {
    marginTop: "1.875rem",
  },
};

export default advantagesLegalbirdAttorneySectionStyle;
